import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { UsersService } from './users.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection!: HubConnection;

  constructor(private _authService: AuthService) {
    
  }

  startConnection() {
    // Also covers Connecting/Reconnecting: building a new connection then would leave the previous one open in the background
    if (this.hubConnection && this.hubConnection.state != HubConnectionState.Disconnected) {
      return;
    }

    // A stopped connection is restarted instead of replaced, so the handlers registered on it are kept
    if (!this.hubConnection) {
      this.hubConnection = new HubConnectionBuilder().withUrl(environment.apiHubUrl,
        {
            withCredentials: false,
            accessTokenFactory: () => this._authService.userData.access_token
        }
      )
      .build();
    }

    this.hubConnection.start()
        .then(() => {
            // You can perform additional actions after the connection is established.
        })
        .catch((err: Error) => {
        }
    );
  }

  closeConnection() {
    // Nothing to close if the connection was never started
    if (!this.hubConnection || this.hubConnection.state === HubConnectionState.Disconnected) {
      return;
    }

    this.hubConnection.stop().catch(() => { });
  }

  // Replaces the method's previous handler, so calling this again (e.g. when the layout is recreated after signing in) doesn't stack handlers
  addMessageListener(method: string, callback: (user: string, message: any, extraData: any) => void) {
    if (!this.hubConnection) {
      return;
    }

    this.hubConnection.off(method);
    this.hubConnection.on(method, (user: string, message: string, extraData: any) => {
      callback(user, message, extraData);
    });
  }

  sendMessage(user: string, message: string) {
    this.hubConnection!.invoke('SendMessage', user, message)
      .catch((err: Error) => {
      });
  }
}
